import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Source() {
    return (
        <OnboardingBody title='…and giving them a source'>
            <p>
                From here, we can identity the channel through which they arrived, such as which
                leads found you via Google or clicked on an email marketing campaign.
            </p>
        </OnboardingBody>
    );
}
